import { initialState } from "../slice/doctorAnalyticSlice";

export const doctorAnalyticAction = {
  yearFilter: (state, action) => {
    state.year = action.payload;
  },

  monthFilter: (state, action) => {
    state.month = action.payload;
  },

  accountFilter: (state, action) => {
    state.account = action.payload;
  },

  sortFilter: (state, action) => {
    state.sort = action.payload;
  },

  nameFilter: (state, action) => {
    state.name = action.payload;
  },

  changeFilter: (state, action) => {
    const { type, value } = action.payload;
    state[type] = value;
  },

  resetFilter: (state) => {
    return initialState;
  },
};
